/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Overdue_AgingInputs */

const en_nav_overdue_aging = /** @type {(inputs: Nav_Overdue_AgingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overdue / Aging`)
};

const es_nav_overdue_aging = /** @type {(inputs: Nav_Overdue_AgingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vencidos / Antiguedad`)
};

/**
* | output |
* | --- |
* | "Overdue / Aging" |
*
* @param {Nav_Overdue_AgingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_overdue_aging = /** @type {((inputs?: Nav_Overdue_AgingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Overdue_AgingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_overdue_aging(inputs)
	return es_nav_overdue_aging(inputs)
});